import { useAuth } from '@/hooks/useAuth'
import { Link } from 'react-router-dom'
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline'

export default function AdminHeader() {
  const { user } = useAuth()

  return (
    <header className="bg-glass border-b border-primary/20 p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <Link
            to="/"
            className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-primary/10 to-secondary/10 border border-primary/30 rounded-lg hover:bg-primary/20 transition-all duration-200 group"
          >
            <ArrowLeftIcon className="w-4 h-4 text-primary group-hover:text-white" />
            <HomeIcon className="w-4 h-4 text-primary group-hover:text-white" />
            <span className="text-primary group-hover:text-white font-medium">Volver al Sitio</span>
          </Link>
          <h1 className="text-2xl font-bold text-white">Panel de Administración</h1>
        </div>
        
        <div className="flex items-center space-x-4">
          <div className="text-right">
            <p className="text-sm text-gray-300">Bienvenido</p>
            <p className="text-sm font-medium text-primary">{user?.email}</p>
          </div>
          <div className="w-10 h-10 bg-gradient-to-r from-primary to-secondary rounded-full flex items-center justify-center">
            <span className="text-dark font-semibold">
              {user?.email?.charAt(0).toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </header>
  )
}
